<template>
    <div class="infos">
        <div class="info"><b>Des offres compétitives</b> pour maîtriser votre budget</div>
        <div class="info"><b>Une offre pour le retrait de la cuve fioul</b></div>
        <div class="info"><b>Des offres de financement dont une prime énergie à taux gratuit</b> pour le passage d'une chaudière fioul à une chaudière gaz propane THPE<sup>(2)</sup></div>
        <div class="info"><b>Des aides de l'État</b> jusqu'à 1200&euro; pour la reprise de la cuve fioul et jusqu'à 1200&euro; pour la Prime Rénov'<sup>(3)</sup></div>
    </div>
</template>

<script>
    export default {
        name: "LandingInfo"
    }
</script>

<style scoped lang="sass">
    @import ../../common/styles/settings
    @import ../../common/styles/mixins
    @import settings
    @import LandingInfo
</style>
